import { errorHandler } from "@/services/toastHandler";

const initState = () => ({
  loadingList: false,
  loadingUpsertSegment: false,
  loadingPreview: false,
  loadingDelete: false,
});

export default {
  namespaced: true,
  state: initState(),
  mutations: {
    LOAD_LIST_SEGMENT: (s, data) => (s.loadingList = data),
    LOAD_UPSERT_SEGMENT: (s, data) => (s.loadingUpsertSegment = data),
    LOAD_PREVIEW_SEGMENT: (s, data) => (s.loadingPreview = data),
    LOAD_DELETE_SEGMENT: (s, data) => (s.loadingDelete = data),
  },

  actions: {
    async getSegmentsList({ commit }, params) {
      commit("LOAD_LIST_SEGMENT", true);
      try {
        const res = await this.$api.get("/v1/portal/customer-segments", {
          params,
        });
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_LIST_SEGMENT", false);
      }
    },
    async upsertSegment({ commit }, params) {
      commit("LOAD_UPSERT_SEGMENT", true);
      try {
        const res = await this.$api.post(
          "/v1/portal/customer-segments",
          params
        );
        return res.data.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_UPSERT_SEGMENT", false);
      }
    },
    async previewSegment({ commit }, params) {
      commit("LOAD_PREVIEW_SEGMENT", true);
      try {
        const res = await this.$api.post(
          "v1/portal/customer-segments/preview",
          params
        );
        return res.data.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_PREVIEW_SEGMENT", false);
      }
    },
    async deleteSegment({ commit }, id) {
      commit("LOAD_DELETE_SEGMENT", true);
      try {
        const res = await this.$api.delete(
          `/v1/portal/customer-segments/${id}`
        );
        return res.data.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_DELETE_SEGMENT", false);
      }
    },
  },
};
